


































































































































































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import topLeft from './top-left.vue';
import topRight from './top-right.vue';
import SearchStore from '../../store/SearchStore';
import DetailStore from '../../store/DetailStore';
import qs from 'qs';
import qsObj from '../../utils/qs';

@Component({
    components: {topLeft, topRight}
})
export default class App extends Vue {
    @Prop(Object)
    searchObj!: any; // 3D 转跳过来会携带

    graphType = 'food';
    placeholder = '请输入商店进行查询';
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    searchValue = '';
    inputLock = false;
    cityArr = ['北京', '上海', '广州', '深圳', '杭州'];
    hackLock = false; // 以后改成outclick的方式 不行这个做法太low了 还浪费时间

    get statisticInfo() {return this.detailData.statisticInfo}
    get callCount() {return this.detailData.statisticInfo.callCount}
    get Entity() {return this.detailData.statisticInfo.Entity}
    get Relation() {return this.detailData.statisticInfo.Relation}

    get historyList() {return this.searchData.historyList}
    get graphInfo () {return this.detailData.graphInfo}



    @Watch('$route')
    onRouteChange (to, from) {
        console.log(to, from);
        debugger
    }

    @Watch('historyList')
    async historyListChange (newVal: any, oldVal: any) {
        // await new Promise(r => setTimeout(r, 200));

        let lastItem = this.historyList.slice(0).pop();
        let lastItemName = lastItem.objectId || lastItem.name || lastItem.id;
        let searchItem = this.searchData.searchItem;

        if (lastItem.subjectId !== searchItem.subjectId ||
            this.searchValue !== lastItemName
        ) {
            SearchStore.setSearchItem(lastItem);
            this.searchValue = lastItemName;
        }
    }

    // 清空输入框逻辑
    graphInfoChange (newVal: any, oldVal: any) {
        let lastItem = this.historyList.slice(0).pop();
        let searchItem = this.searchData.searchItem;
        console.log(lastItem.subjectId, this.searchData.subjectId);
        if (lastItem.subjectId !== searchItem.subjectId) {
            this.searchValue = '';
        }
    }

    changeCity (city) {
        SearchStore.changeFilterCity(city);
        SearchStore.suggest({
            str: (this.$refs.input as HTMLInputElement).value,
            city
        });
    }

    async sugClickHandler(item) {
        console.log('sugClickHandler', item);

        if (this.graphType === 'finance') {
            // SearchStore.searchFinanceEnter('');
            console.log(item);
            item.customType = 'user';
            this.searchValue = item.objectId;
            SearchStore.clearSuggest();
            SearchStore.setSearchItem(item);
            return void 0;
        }

        this.searchValue = item.id;
        SearchStore.clearSuggest();
        SearchStore.setSearchItem(item);

        // TODO 复用
        let {subjectId, entityType} = this.searchData.searchItem;
        if (entityType === 'user') {
            DetailStore.getUserDataBySubjectId(subjectId);
            DetailStore.getUserGraph({subjectId});
            // DetailStore.changeLoading('global', false);
        } else if (entityType === 'poi') {
            DetailStore.getPoiDataBySubjectId(subjectId);
            DetailStore.getPoiGraph({subjectId});
        }
    }

    async searchRequest(str) {
        if (this.graphType === 'finance') {
            await SearchStore.searchFinanceEnter(str);
            return void 0;
        }

        let res = await SearchStore.search(str);
        if (this.detailData.access === 403) {
            return void 0;
        }

        // TODO 复用
        let {subjectId, entityType} = this.searchData.searchItem;
        if (entityType === 'user') {
            DetailStore.getUserDataBySubjectId(subjectId);
            DetailStore.getUserGraph({subjectId});
        } else if (entityType === 'poi') {
            DetailStore.getPoiDataBySubjectId(subjectId);
            DetailStore.getPoiGraph({subjectId});
        }
    }

    changeSidebar () {
        // DetailStore.changeLoading({type: 'leftRight', flag: !this.detailData.loading.leftRight})
    }

    onSearchBlur () {
        console.log('onSearchBlur');
        setTimeout(() => {
            if (this.hackLock) {
                return void 0;
            }
            SearchStore.clearSuggest();
        }, 500)
    }

    // TODO 是否要tip
    onSearchFocus (e) {

    }

    // TODO 节流
    triggerInput (str) {
        console.log(str);
        if (this.graphType === 'food') {
            SearchStore.suggest({str});
        } else if (this.graphType === 'finance') {
            SearchStore.searchFinance(str);
        }
    }

    // 解决中文输入法问题
    onSearchInput (e) {!this.inputLock && this.triggerInput(e.target.value);}
    onSearchCompositionstart (e) {this.inputLock = true;}
    onSearchCompositionend (e) {this.inputLock = false;this.triggerInput(e.target.value);}

    async onSearchHandler(e) {
        let value: string = (this.$refs.input as HTMLInputElement).value.trim();
        if (!value) {
            this.$message.error('请输入内容');
            return void 0;
        }
        await this.searchRequest(value);
    }

    // TODO off
    closeout () {
        $('body').click((e) => {
            if( !$( e.target ).closest('.search-inner').length ){
                SearchStore.clearSuggest();
            }
        });
    }

    async mounted () {
        let { fullPath } = this.$route;
        if (fullPath === '/finance') {
            this.placeholder = '请输入userid、手机号查询';
            this.graphType = 'finance';
        } else {
            this.graphType = 'food';
        }

        this.closeout();

        DetailStore.getStatistic();

        if (this.searchObj && this.searchObj.id) {
            SearchStore.setSearchItem({...this.searchObj, subjectId: this.searchObj.id});
            DetailStore.getPoiDataBySubjectId(this.searchObj.id);
            DetailStore.getPoiGraph({subjectId: this.searchObj.id});
            return void 0;
        }

        let defaultSearch = '';
        if (qsObj.s) {
            let searchString = qsObj.s || defaultSearch;
            this.searchValue = searchString;
            await this.searchRequest(searchString);
        }
    }
}
